import type {Editor} from 'grapesjs';
import type {EditorViewport} from '@EmailMakerReact/email-maker-react.types';

export const ICON_EYE = 'icon-eye';
export const I18N_PREVIEW_KEY = 'pmwjs_preview';

export interface PreviewButtonProps {
  editorViewport: EditorViewport;
  editor: Editor | null;
}
